import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const ScalingInLine = ({ price, quantityBasisValue, size, scaleY, portalRef }) => {
  const json = {
    Category: 'Position Tactic',
    Type: 'Scaling In',
    'Price': ApplyRounding(Number(price), 2),
    'Qty. Basis': quantityBasisValue
  };
  return (
    <>
      {scaleY ? (
        <>
          <line
            stroke={colors.blue}
            strokeWidth={2}
            x1={0}
            x2={size}
            y1={scaleY(Number(price))}
            y2={scaleY(Number(price))}
          ></line>
          <HoverBox
            json={json}
            topBoundary={scaleY(Number(price)) - 2}
            bottomBoundary={scaleY(Number(price)) + 2}
            leftBoundary={0}
            rightBoundary={size}
            portalRef={portalRef}
            size={size}
          />
        </>
      ) : null}
    </>
  );
};

ScalingInLine.propTypes = {
  price: PropTypes.number,
  quantityBasisValue: PropTypes.number,
  scaleY: PropTypes.func,
  size: PropTypes.any,
  portalRef: PropTypes.object
};
